import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { errorStyle } from './styles';

const renderCheckbox = ({ meta: { visited, touched, error }, input, label, ...custom }) => {
  // Defensive: provide safe defaults if input is null/undefined
  const safeInput = input || { value: false, onChange: () => {} };
  
  return (
    <React.Fragment>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!safeInput.value}
            onChange={safeInput.onChange}
            {...custom}
          />
        }
        label={label}
      />
      {(touched || visited) && (error && (
        <span style={errorStyle}>
          {error}
        </span>
      ))}
    </React.Fragment>
  );
};

renderCheckbox.defaultProps = {
  input: null,
  label: '',
  meta: {
    visited: false,
    error: '',
    touched: false,
  },
};

renderCheckbox.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func,
  }),
  label: PropTypes.string,
  meta: PropTypes.shape({
    visited: PropTypes.bool,
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default renderCheckbox;
